import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getRawMaterialList = createAsyncThunk("/getRawMaterialList", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}rawMaterial/api/v1/get-all`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("raw material response", response);
    return response?.data; // returns { success, message, Total, data } 
  } catch (error) {
    console.error("Error fetching Raw Material", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Raw Material");
  }
});
